import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { FileModel } from '../../models/file/file.model';

import { fileDeleted, setFiles, setSingleFile } from './files.actions';

export interface FilesState extends EntityState<FileModel> {}

export const filesAdapter: EntityAdapter<FileModel> = createEntityAdapter<FileModel>();
const initialState: FilesState = filesAdapter.getInitialState();

export const filesReducer = createReducer(
  initialState,
  on(setFiles, (state, { payload }): FilesState => {
    return filesAdapter.setAll(payload, state);
  }),
  on(setSingleFile, (state, { payload }): FilesState => {
    return filesAdapter.upsertOne(payload as unknown as FileModel, state);
  }),
  on(fileDeleted, (state, { payload }): FilesState => {
    return filesAdapter.removeOne((payload as any).id ?? payload, state);
  }),
);
